export const environment = {
	production: false,
	serverUrl: "",
	clientUrl: "",
};
